// Modulo para la traduccion de campos de la tabla de promociones
import React , { useEffect, useState } from 'react'

import { ApiCallPost , ApiCallGet } from '../../ApiCall/ApiCall';

import AsyncSelect from 'react-select/async';



export default function Translate() {


    const [idArticulo,setIdArticulo] = useState( 0 ) ;


    function onPrevio()
    {

        console.log("idArticulo = ", idArticulo)
        // gettranslateindex , index , updown

        ApiCallGet( 'gettranslateindex?index=' + idArticulo +'&updown=d' )
        .then( (response) => {

            console.log("response = ", response)

            if ( response.length > 0 )
            {
                setIdArticulo( response[0].idrecuenbot )
                showFields( response ) ;            
            }

        })
        .catch( (error) => {

            console.log("error = ", error)

        } )


    }

    function onSiguiente()
    {

        console.log("idArticulo = ", idArticulo)
        // gettranslateindex , index , updown

        ApiCallGet( 'gettranslateindex?index=' + idArticulo +'&updown=u' )
        .then( (response) => {

            console.log("response = ", response)

            if ( response.length > 0 )
            {
                setIdArticulo( response[0].idrecuenbot )
                showFields( response ) ;            }

        })
        .catch( (error) => {

            console.log("error = ", error)

        } )



    }


    useEffect(() => {
        console.log("idArticulo = ", idArticulo)
        // gettranslateindex , index , updown

        ApiCallGet( 'gettranslateindex?index=0&updown=u' )
        .then( (response) => {

            console.log("response = ", response)

            if ( response.length > 0 )
            {
                setIdArticulo( response[0].idrecuenbot )
                showFields( response ) ;


            }

        })
        .catch( (error) => {

            console.log("error = ", error)

        } )

    } , []) // Lo cargamos al inicio ( nos traemos el primero )


    const loadOptions = (inputValue, callback) => {

        console.log("inputValue ( load options ) = ", inputValue)


        if ( inputValue.length < 2 )
        {
            callback([])
            return ;
        }

        console.log( "Vamos a procesar")

        ApiCallGet( 'getpromo/?sku='+ inputValue )
        .then( (response) => {

            console.log("promo = ", response)

            var arr = []

            console.log("response.length = ", response.length )

            if ( response.length > 0 )
            {

                for( var i = 0 ; i < response.length ; i++ )
                {
                    var item = response[i]

                    //console.log("item = ", item)

                    var obj = { value : item.sku , label : item.sku  + " " + item.descripcion }

                    arr.push( obj )
                }
                
            }

            console.log("arr = ", arr)

            if ( arr.length === 0 )
            {
                //setAddDivisa( true )
            }
            else{
                //setAddDivisa( false )
            }

            callback( arr ) // Regresamos el arreglo de las divisas seleccionadas

            

        })
        .catch( (error) => {

            console.log("error = ", error)
            callback( [] ) // Regresamos el arreglo vacio 

        })
    


        

    }


    function setInputValue(val){
        console.log("setInputValue = ", val)

        if ( val === "")
        {

            //var letrero = document.getElementById('buttonadd').innerText

            //console.log("addDivisda*** = ", letrero )
            //console.log( "candidate = " + candidate )

            if ( true /* letrero === "AGREGAR MONEDA" */)
            {
                //setShowMonedas( true )
                return ;
            }

            //setAddDivisa( false )
        }
    }


    function onCuentaChange( val )
    {
        console.log("onCuentaChange*** = ", val)

        // Value = sku

        ApiCallGet( 'gettranslate/?sku='+ val.value )
        .then( (response) => {

            console.log("descuento = ", response)

            if ( response.length > 0 )
            {

                setIdArticulo( response[0].idrecuenbot )


                showFields( response ) ;


            }


        })
        .catch( (error) => {

            console.log("error = ", error)

        })  

       

    }

    function showFields( response )
    {
        // { value : item.sku , label : item.sku  + " " + item.descripcion }
        document.getElementById('info').value = { value : response[0].sku , label : response[0].sku  + " " + response[0].descripcion }
        document.getElementById('sku').value = response[0].sku + " " + response[0].descripcion
        document.getElementById('descengarea').innerHTML = response[0].availability
        document.getElementById('descsparea').innerHTML = response[0].availabilitysp
        // title ( title ) , titulo ( titlesp )
        document.getElementById('title').innerHTML = response[0].title
        document.getElementById('titulo').innerHTML = response[0].titlesp


        

        document.getElementById('warranty').innerHTML = response[0].warranty
        document.getElementById('garantia').innerHTML = response[0].warrantysp

    }

    function onPostData()
    {
        //e.preventDefaul() ;

        console.log( "Estamos es postData")

        var obj = {
           
            idrecuenbot : idArticulo ,

            
           
            availabilitysp : document.getElementById('descsparea').value ,
            
            titlesp : document.getElementById('titulo').value ,
            
            warrantysp : document.getElementById('garantia').value ,
        }

        // updatetranslate

        ApiCallPost( "updatetranslate" , obj)
        .then( (response) => {

            console.log("response = ", response)

        })
        .catch( (error) => {

            console.log("error = ", error)

        })
        // Aqui armamos los datos a enviar 
    }






  return (
    <div className='box-1 backemployer-2 centersearch w-100 m-1 align-items-center' >
    <div className='d-flex flex-column  box-1 backemployer-2 mb-5 form-2 w-100' 
     id="page1" style={{fontSize:'16px' , margin :'auto'}} >

        <div className='row'>
              <div className='col-sm-8'>
                <h5>Administrador de traduccion de Promociones</h5>
              </div>
        </div>

        <div className='row'>

        
            <div className='col-sm-6'>
                        <div className="form-group"  style={{width: "100%" }} >
                            <label className="form-label m-0" htmlFor="info">Artículo</label>

                            <AsyncSelect className='pt-2'
                                id="info" cacheOptions
                                loadOptions={loadOptions} onChange={onCuentaChange}
                                onInputChange={(value) => setInputValue(value)} placeholder="Valor"/>
                        </div>
            </div>

            <div class="col-sm-3 mt-3">

                <button type='button' title='Registro Previo' 
                    style={{borderRadius : '8px'}} onClick={onPrevio} >Previo</button>

            </div>
            <div class="col-sm-3 mt-3">

                <button type='button' title='Registro Siguiente'
                    style={{borderRadius : '8px'}} onClick={onSiguiente} >Siguiente</button>

            </div>
        
        </div>

        <div className='row'>

            <div className='col-sm-4'>
                <label className="form-label mb-0 mt-4" htmlFor='sku' >SKU</label>
                <input type='text' readOnly id='sku'/>

            </div>

        </div>


        <div className='row'>
            <div className='col-sm-6'>
                <div className="form-group"  style={{width: "100%" }} >
                    <label className="form-label m-0" htmlFor="descengarea">Availability(eng)</label>
                    <textarea readOnly class="form-control" rows={3} id="descengarea" ></textarea>
                </div>
            </div>

            <div className='col-sm-6'>
                <div className="form-group"  style={{width: "100%" }} >
                    <label className="form-label m-0" htmlFor="descsparea">Disponibilidad(esp)</label>
                    <textarea class="form-control" rows={3} id="descsparea" ></textarea>
                </div>

            </div>
        </div>

        <div className='row'>
            <div className='col-sm-6'>
                <div className="form-group"  style={{width: "100%" }} >
                    <label className="form-label m-0" htmlFor="title">Title(eng)</label>
                    <textarea readOnly class="form-control" rows={3} id="title" ></textarea>
                </div>
            </div>

            <div className='col-sm-6'>
                <div className="form-group"  style={{width: "100%" }} >
                    <label className="form-label m-0" htmlFor="titulo">Titulo(esp)</label>
                    <textarea class="form-control" rows={3} id="titulo" ></textarea>
                </div>

            </div>
        </div>

        <div className='row'>
            <div className='col-sm-6'>
                <div className="form-group"  style={{width: "100%" }} >
                    <label className="form-label m-0" htmlFor="warranty">Warranty(eng)</label>
                    <textarea readOnly class="form-control" rows={3} id="warranty" ></textarea>
                </div>
            </div>

            <div className='col-sm-6'>
                <div className="form-group"  style={{width: "100%" }} >
                    <label className="form-label m-0" htmlFor="garantia">Garantía(esp)</label>
                    <textarea class="form-control" rows={3} id="garantia" ></textarea>
                </div>

            </div>
        </div>

        <div class="row mt-4">

            <div class="col-sm-4">

                <button type='button'   style={{borderRadius : '8px' }} onClick={onPostData} >Actualizar Datos</button>

            </div>

        </div>





    </div>
    </div>
  )
}
